import React from 'react';
import PropTypes from 'prop-types';

import TextField from './text_field';

const MinPasswordLength = 8;

class PasswordField extends TextField {
  constructor(props) {
    super(props);

    this.fieldType = 'password';
    this.validations.push(this.validatePasswordLength);
  }

  validatePasswordLength(value) {
    if (value.length < MinPasswordLength) {
      return 'Password needs to be at least 8 characters';
    }
  }
}

PasswordField.propTypes = {
  updateModel: PropTypes.func.isRequired,
  updateErrorMessage: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  onValid: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  required: PropTypes.bool,
  value: PropTypes.string,
  className: PropTypes.string,
  displayName: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
};

export default PasswordField;
